// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableCell, TableRow } from 'material-ui-next/Table';

// Internal Dependencies
import connectComponent from '../../connect-component';
import { fetchBadges } from '../../state/actions/badge-actions';
import { fetchCoders } from '../../state/actions/coders-actions';
import { dialogForm, dialogOpen } from '../../state/ui/update-ninjas/add-ninja-dialog/actions';

// Local Variables
const propTypes = {
  coders: PropTypes.arrayOf(PropTypes.object),
  fetchBadges: PropTypes.func,
  fetchCoders: PropTypes.func,
  ninjasSelected: PropTypes.arrayOf(PropTypes.number),
  pageNumber: PropTypes.number,
  rowsPerPage: PropTypes.number,
  searchStringTyped: PropTypes.string,
  updateDialogForm: PropTypes.func,
  openDialog: PropTypes.func,
};

const defaultProps = {
  coders: [],
  fetchBadges: null,
  fetchCoders: null,
  ninjasSelected: [],
  pageNumber: 0,
  rowsPerPage: 10,
  searchStringTyped: '',
  updateDialogForm: null,
  openDialog: null,
};

const nameStyles = {
  paddingLeft: 16,
};

// Component Definition
class NinjasTableRows extends Component {

  componentDidMount() {
    Promise.all([
      this.props.fetchCoders(),
      this.props.fetchBadges(),
    ]);
  }

  getSelection = id => this.props.ninjasSelected.indexOf(id) !== -1;

  handleClickrow = (event, coder) => {
    event.stopPropagation();
    const ninja = {
      coderAttendance: coder.attendance,
      coderBadges: coder.badges,
      firstName: coder.firstName,
      id: coder.key,
      lastName: coder.lastName,
      title: coder.title,
    };

    Promise.all([
      this.props.updateDialogForm(ninja),
      this.props.openDialog(),
    ]);
  }

  render() {
    const { coders,
      pageNumber,
      rowsPerPage,
      searchStringTyped,
    } = this.props;

    const emptyRows = rowsPerPage - Math.min(rowsPerPage,
      coders.length - (pageNumber * rowsPerPage));

    const filteredCoders = Object.keys(coders).filter((key) => {
      const name = `${coders[key].firstName} ${coders[key].lastName}`;
      return name.toLowerCase().indexOf(searchStringTyped) !== -1;
    })
    .map(key => coders[key],
    );

    const getLastAttendance = (attendance) => {
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      const last = attendance[Object.keys(attendance)[Object.keys(attendance).length - 1]];
      const prettyDate = new Date(last).toLocaleDateString('en-us', options);
      return prettyDate;
    };

    const renderRows = () => {
      if (!filteredCoders) return null;
      return filteredCoders.slice(pageNumber * rowsPerPage,
        (pageNumber * rowsPerPage) + rowsPerPage)
        .map(coder => (
          <TableRow
            hover
            onClick={event => this.handleClickrow(event, coder)}
            key={coder.key}
            role="checkbox"
            aria-checked={this.getSelection(coder.key)}
            tabIndex={-1}
            selected={this.getSelection(coder.key)}
          >
            <TableCell padding="none">
              <span style={nameStyles}>{`${coder.firstName} ${coder.lastName}`}</span>
            </TableCell>
            <TableCell>{coder.title}</TableCell>
            <TableCell>{getLastAttendance(coder.attendance)}</TableCell>
            <TableCell>{coder.badges ? coder.badges.length : 0}</TableCell>
          </TableRow>
      ));
    };

    const extraRow = emptyRows > 0 && (
      <TableRow style={{ height: 49 * emptyRows }}>
        <TableCell colSpan={6} />
      </TableRow>
    );

    return (
      <TableBody>
        {renderRows()}
        {extraRow}
      </TableBody>

    );
  }
}

NinjasTableRows.propTypes = propTypes;
NinjasTableRows.defaultProps = defaultProps;
export default connectComponent((state) => {
  const { coders, ui } = state;
  const {
    ninjasSelected,
    pageNumber,
    rowsPerPage,
    searchStringTyped,
  } = ui.updateNinjas;
  return {
    coders,
    ninjasSelected,
    pageNumber,
    rowsPerPage,
    searchStringTyped,
  };
}, {
  fetchBadges,
  fetchCoders,
  updateDialogForm: dialogForm,
  openDialog: dialogOpen,
}, NinjasTableRows);




/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/ninjas-table-rows.js
 **/